module.exports = __webpack_public_path__ + "img/order.37115504.png";